import { ADD_TEAM_MEMBERS_OVERLAY } from "shared/context/overlay/types"
import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { useProjectTeamData } from "features/project-team/model/useProjectTeamData"
import { useTeamScopedTeamMemberActionHandlers } from "features/team-member-management/model/useTeamScopedTeamMemberActionHandlers"
import { useTeamScopedTeamMemberFormHandlers } from "features/team-member-management/model/useTeamScopedTeamMemberFormHandlers"

import { ManageProjectTeamOverlayModel } from "../ManageProjectTeamOverlay"
import { ManageProjectTeamOverlayConnectorProps } from "../ManageProjectTeamOverlayConnector"

export function useManageProjectTeamOverlayModel({
  payload: { projectID },
  ...rest
}: ManageProjectTeamOverlayConnectorProps): ManageProjectTeamOverlayModel {
  const { userInfo } = useAuth()
  const { team, isLoading } = useProjectTeamData({ projectID })

  const { handleDeleteTeamMember, handleResendInvitation } =
    useTeamScopedTeamMemberActionHandlers(team?.id || "")
  const { handleCreateMultipleTeamMembers, handleUpdateTeamMember } =
    useTeamScopedTeamMemberFormHandlers(team?.id || "")

  const { openOverlay: openMultiInvitesFormOverlay } = useOverlay(
    ADD_TEAM_MEMBERS_OVERLAY
  )

  const handleOpenMultiInvitesFormOverlay = useEvent(() => {
    openMultiInvitesFormOverlay({
      projectID
    })
  })

  // Extract current user email and existing team member emails for validation
  const currentUserEmail = userInfo?.email
  const existingTeamMemberEmails = team?.memberships
    ?.map(member => member.user?.email)
    .filter(Boolean) as string[]

  return {
    ...rest,
    projectID,
    team,
    isLoadingTeam: isLoading,
    onSubmit: handleCreateMultipleTeamMembers,
    onUpdateTeamMember: handleUpdateTeamMember,
    onDeleteTeamMember: handleDeleteTeamMember,
    onResendInvitation: handleResendInvitation,
    onInviteMore: handleOpenMultiInvitesFormOverlay,
    currentUserEmail,
    existingTeamMemberEmails
  }
}
